import React from 'react';
import styled from 'styled-components';
import { token, IconPlusOutline, Button, Text } from '@zillow/constellation';
import { DropZoneOverlay, DropZoneRendererProps } from './DropZone';
import { DEFAULT_PLACEHOLDER_TEXT } from '../lib/constants';

const Container = styled.div<{ isDragOutside: boolean; isDragInside: boolean }>`
  position: relative;
  outline: none;
  height: 15rem;
  display: flex;
  justify-content: center;
  border: ${props =>
    props.isDragInside
      ? `2px dashed ${token('colors.blue400')(props)}`
      : props.isDragOutside
      ? `1px solid ${token('colors.blue400')(props)}`
      : `2px dashed ${token('colors.gray300')(props)}`};
`;

const Placeholder = styled.div`
  max-width: 32rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`;

const AddFilesButton = styled(Button)`
  width: 10rem;
  margin: 1.75rem auto 1rem auto;
  white-space: nowrap;
`;

export type PlaceholderTextProps = {
  /** Upload drop zone placeholder text. */
  placeholderText?: React.ReactNode;
};

export type DropZonePlaceholderConsumableProps = {
  canAddFiles: boolean;
  addFilesDescription: string;
} & PlaceholderTextProps &
  DropZoneRendererProps;

export type Props = {
  className?: string;
} & DropZonePlaceholderConsumableProps;

function DropZonePlaceholder({
  isDragOutside,
  isDragInside,
  canAddFiles,
  onAddFiles,
  addFilesDescription,
  placeholderText = DEFAULT_PLACEHOLDER_TEXT,
  className,
}: Props) {
  return (
    <Container
      isDragOutside={isDragOutside}
      isDragInside={isDragInside}
      className={className}
    >
      {isDragInside && <DropZoneOverlay />}
      <Placeholder>
        <Text>{placeholderText}</Text>
        <AddFilesButton
          buttonType="primary"
          type="button"
          disabled={!canAddFiles}
          onClick={onAddFiles}
          icon={<IconPlusOutline />}
        >
          {addFilesDescription}
        </AddFilesButton>
        <Text fontType="bodySmall">You may also drop files here or paste.</Text>
      </Placeholder>
    </Container>
  );
}

export default DropZonePlaceholder;
